import { Box } from "@mui/material"

// Wrapper to avoid MUI Menu's type-ahead, which would steal keystrokes from
// the search field to jump to a MenuItem by its first letter.
export const MenuItemContainer = Box
